module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.nome),
      expression: "filter.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.filter.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.email),
      expression: "filter.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.filter.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("CPF")]), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": "111.111.111-11"
    },
    model: {
      value: (_vm.filter.cpf),
      callback: function($$v) {
        _vm.$set(_vm.filter, "cpf", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "filter.cpf"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": "(11) 11111-1111"
    },
    model: {
      value: (_vm.filter.telefone),
      callback: function($$v) {
        _vm.$set(_vm.filter, "telefone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "filter.telefone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Código Operadora")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.codigoOperadora),
      expression: "filter.codigoOperadora"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.filter.codigoOperadora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "codigoOperadora", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Assinatura")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.assinaturaStatus,
      "placeholder": "Selecione",
      "select-option": true
    },
    model: {
      value: (_vm.filter.assinatura),
      callback: function($$v) {
        _vm.$set(_vm.filter, "assinatura", $$v)
      },
      expression: "filter.assinatura"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Apólice Emitida")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.simNao,
      "placeholder": "Selecione",
      "select-option": true
    },
    model: {
      value: (_vm.filter.apolice),
      callback: function($$v) {
        _vm.$set(_vm.filter, "apolice", $$v)
      },
      expression: "filter.apolice"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Possui Email?")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.simNao,
      "placeholder": "Selecione",
      "select-option": true
    },
    model: {
      value: (_vm.filter.possuiEmail),
      callback: function($$v) {
        _vm.$set(_vm.filter, "possuiEmail", $$v)
      },
      expression: "filter.possuiEmail"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Possui CPF?")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.simNao,
      "placeholder": "Selecione",
      "select-option": true
    },
    model: {
      value: (_vm.filter.possuiCPF),
      callback: function($$v) {
        _vm.$set(_vm.filter, "possuiCPF", $$v)
      },
      expression: "filter.possuiCPF"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Operadora/Loja")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.assinaturaTipo,
      "placeholder": "Selecione",
      "select-option": true
    },
    model: {
      value: (_vm.filter.assinaturaTipo),
      callback: function($$v) {
        _vm.$set(_vm.filter, "assinaturaTipo", $$v)
      },
      expression: "filter.assinaturaTipo"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Data Assinatura")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.config,
      "placeholder": "Selecione",
      "name": "date"
    },
    model: {
      value: (_vm.filter.dataAssinatura),
      callback: function($$v) {
        _vm.$set(_vm.filter, "dataAssinatura", $$v)
      },
      expression: "filter.dataAssinatura"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('label', [_vm._v("Data Cancelamento")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.config,
      "placeholder": "Selecione",
      "name": "date"
    },
    model: {
      value: (_vm.filter.dataCancelamento),
      callback: function($$v) {
        _vm.$set(_vm.filter, "dataCancelamento", $$v)
      },
      expression: "filter.dataCancelamento"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("País")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": '/pais/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.filter.assinaturaPais),
      callback: function($$v) {
        _vm.$set(_vm.filter, "assinaturaPais", $$v)
      },
      expression: "filter.assinaturaPais"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Integradora")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.assinaturaIntegradora,
      "placeholder": "Selecione",
      "select-option": true
    },
    model: {
      value: (_vm.filter.assinaturaIntegradora),
      callback: function($$v) {
        _vm.$set(_vm.filter, "assinaturaIntegradora", $$v)
      },
      expression: "filter.assinaturaIntegradora"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione")])])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('ul', {
    staticClass: "toggle-list"
  }, [_c('li', [_c('label', [_vm._v("Ativo")]), _vm._v(" "), _c('input-toggle', {
    attrs: {
      "value": _vm.filter.ativo
    },
    model: {
      value: (_vm.filter.ativo),
      callback: function($$v) {
        _vm.$set(_vm.filter, "ativo", $$v)
      },
      expression: "filter.ativo"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n                                    Novo Cliente\n                                    "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clean
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _vm._m(1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('dw-table-header', {
    attrs: {
      "size": _vm.size,
      "pagination": _vm.list
    },
    on: {
      "finish": _vm.updateSize
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-md"
  }, [_c('dw-table-head', {
    attrs: {
      "headers": _vm.headers,
      "editable": true
    },
    on: {
      "update": _vm.sort
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.list.rows), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-label": _vm.headers[0].name
      }
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[1].name
      }
    }, [_vm._v("\n                                    " + _vm._s((item.nome ? item.nome : 'NC')) + "\n                                    "), (item.ativo) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Ativo")]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Inativo")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[2].name
      }
    }, [_vm._v(_vm._s(item.telefone))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[3].name
      }
    }, [_vm._v(_vm._s(item.codigoOperadora))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[4].name
      }
    }, [_vm._v(_vm._s(item.cpf))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[5].name
      }
    }, [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[6].name
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.criado_em, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[7].name
      }
    }, [_vm._v(_vm._s((item.assinatura ? item.assinatura.tipo : '')))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[8].name
      }
    }, [(!item.assinatura) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Sem Assinatura")]) : (item.assinatura.status == 'I') ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Ativo")]) : (item.assinatura.status == 'C') ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Cancelado")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[9].name
      }
    }, [(item.assinatura) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("formatDate")(item.assinatura.dataTransacao, 'DD/MM/YYYY HH:mm')) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[10].name
      }
    }, [(item.assinatura) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("formatDate")(item.assinatura.dataInicio, 'DD/MM/YYYY HH:mm')) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[11].name
      }
    }, [(item.assinatura) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("formatDate")(item.assinatura.dataFim, 'DD/MM/YYYY HH:mm')) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[12].name
      }
    }, [(item.apolice && item.apolice.length > 0) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Emitida")]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Sem Apólices")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[13].name
      }
    }, [(item.apolice && item.apolice.length > 0) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("formatDate")(item.apolice[0].dataInicio, 'DD/MM/YYYY HH:mm')) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[14].name
      }
    }, [(item.apolice && item.apolice.length > 0) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("formatDate")(item.apolice[0].dataFim, 'DD/MM/YYYY HH:mm')) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.edit(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('Apólices'),
        expression: "'Apólices'"
      }],
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          _vm.apolicy(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-file-contract"
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'list-pet',
          params: {
            idCliente: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paw"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])], 1)])
  }))], 1), _vm._v(" "), _c('dw-pagination', {
    attrs: {
      "pagination": _vm.list,
      "page": _vm.page,
      "offset": _vm.size
    },
    on: {
      "update": _vm.fetchData
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n                                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68ee3885","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/client/List.vue
// module id = 879
// module chunks = 1